<script>
  import {paylessMethods} from '@state/helpers'
  import { mapGetters } from 'vuex'
  import {Money} from 'v-money'
  
  export default {
    name: 'ThirdpartyPaylessModal',
    components: {
      Money 
    },
    props: {
      instanceJson: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      oncomplete: {
        type: Function,
        required: false,
        default: () => ({}),
      },
      oncancel: {
        type: Function,
        required: false,
        default: () => ({}),
      },
    },
    data() {
      return {
        modalShow: true,
        showFormConfirm:false,
        qr:'',
        loading: false,
        toDetail: {},
        state: '- - -',
        textValid:null,
        value: null,
        textError: null,
        errorAmount:false,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '$ ',
          suffix: '',
          precision: 0,
          masked: false
        }
      }
    },
    computed: {
      ...mapGetters({
        stores: 'captacionPos/stores',
        store: 'captacionPos/store',
        cashRegister: 'captacionPos/cashRegister',
      }),
    },
    watch: {
    },
  
    mounted: function () {
      let context = this
      if (context.instanceJson.error) {
          context.state = 'invalid'
          context.textError = context.instanceJson.messageError
      } else {
        context.value=context.instanceJson.amount_payless
        context.copyClipboard(context.instanceJson.order.barcode)
        setTimeout(() => {
          var inputElement = document.getElementById('amount_input');
          inputElement.focus();
        }, 500)
      }
    },
  
    methods: {
      ...paylessMethods,
  
      copyClipboard(value){
        setTimeout(() => {
              navigator.clipboard.writeText(value)
            }, 500)
      },
      oncancelConfirm(){
        this.showFormConfirm = false
      },
      authorize() {
        let context = this
        context.state = 'loading'
        context.showFormConfirm=false
        if(context.instanceJson.order.amount!=0 && context.instanceJson.order.amount!=null){
          return context.paylessAuthorizeOrder(context.instanceJson.order)
            .then((response) => {
              setTimeout(() => {
                if(response.response_data){
                  if(response.response_data.status==='payment_authorization_request_succeeded'){
                    context.textValid='Autorización realizada con éxito'
                    context.state = 'valid'
                  }
                } else{
                  context.state = 'invalid'
                  context.textError = response.details
                }
                this.errorAmount=false
              }, 500)
            })
            .catch((error) => {
              console.log('error:',error)
              context.state = 'invalid'
              context.textError = 'Error al autorizar la orden'
              this.errorAmount=false
            })
        } else{
          this.errorAmount=true
          context.state = 'info'
        }
      },
    },
  }
  </script>
  
  <template>
    <b-modal
      v-model="modalShow"
      ref="couponModal"
      :title="`${$t('detail_of')} ${$t('thirdparty')}`"
      size="lg"
      class="bg-transparent"
      centered
      :hide-header="true"
      :hide-footer="true"
      :no-close-on-esc="true"
      ok-only
      content-class="bg-transparent"
      @hidden="oncancel"
    >
      <b-container class="p-0 bg-transparent">
        <b-row v-if="loading">
          <b-col md="12">
            <div class="text-center">
              <b-spinner
                label="Spinning"
                style="color: #195db2; width: 4rem; height: 4rem"
              ></b-spinner>
            </div>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col md="12">
            <b-button variant="outline-light rounded-circle btn-close shadow"
            @click="() => modalShow = false"
            ><i class="fas fa-arrow-left"></i></b-button>
            <div
            class="
            coupon
            d-flex
            flex-column
            justify-content-center
            align-items-center
            "
            :class="{
              'bg-valid': state === 'valid',
              'bg-expired': state === 'expired' || state === 'redeemed',
              'bg-invalid': state === 'invalid',
            }"
            >
              <div class="icon-animated">
                <sweetalert-icon
                  v-if="state === 'valid'"
                  icon="success"
                  color="#FFFFFF"
                />
                <sweetalert-icon
                  v-else-if="state === 'expired' || state === 'redeemed'"
                  icon="info"
                  color="#FFFFFF"
                />
                <sweetalert-icon
                  v-else-if="state === 'loading'"
                  icon="loading"
                  color="#FFFFFF"
                />
                <sweetalert-icon
                  v-else-if="state === 'invalid'"
                  icon="error"
                  color="#FFFFFF"
                />
              </div>
              <div class="icon-logo focused-div">
                <b-avatar
                rounded
                size="6rem"
                class="shadow mt-3"
                :src="require('@assets/images/logos/rappi-logo.webp')"
              ></b-avatar>
              </div>
              <h5 v-if="!instanceJson.error" class="text-white text-center">Código de pago: {{ instanceJson.order.barcode }}</h5>
              <div style="display: flex; align-items: center; justify-content: center;">
                <h3 class="text-white">$ {{ value ? $formatDollar(value) : '* * * * *' }}</h3>
                <div class="pl-3 col-6" v-if="state!='invalid'">
                  <b-form @submit.prevent="state==='invalid' || state==='valid' || state==='loading' ? state==='loading' ? state='loading' : modalShow=false : showFormConfirm=true">
                    <money id="amount_input" v-model="instanceJson.order.amount" v-bind="money" class="form-control font-20 font-weight-bold border-white text-white bg-transparent"></money>
                  </b-form>
                  <p class="text-danger text-center" style="max-width: 100%; margin: 0;" v-if="errorAmount">Ingresar valor a facturar</p>
                </div>
              </div>
              <div style="text-align: -webkit-center;">
                <p v-if="instanceJson.order && state!='invalid'" class="text-white text-center" style="max-width: 80%; margin: 0;">Facturar con el tipo de cliente crédito a nombre del NIT <strong style="font-size: 1.21rem;" class="text-white">900843898</strong></p>
                <div style="max-height: 230px; max-width: 80%; overflow-y: auto; margin-bottom: 10px;">
                  <table v-if="instanceJson.order && state!='invalid'" class="text-white text-center" style="border-collapse:collapse; width: 100%;">
                    <thead>
                      <tr>
                        <th class="border_celda">Código de barras</th>
                        <th class="border_celda">Descripción</th>
                        <th class="border_celda">Cantidad</th>
                        <th class="border_celda">Prec. Unit.</th>
                        <th class="border_celda">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="product in instanceJson.order.basket" :key="product.ean">
                        <td class="border_celda">{{ product.ean }}</td>
                        <td class="border_celda">{{ product.description }}</td>
                        <td class="border_celda">{{ product.quantity }} ({{product.unit_type}})</td>
                        <td class="border_celda">{{ $formatDollar(product.unit_price) }}</td>
                        <td class="border_celda">{{ product.unit_type == 'GR' ? $formatDollar(product.unit_price*product.quantity/1000) : $formatDollar(product.unit_price*product.quantity) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h5 v-if="state=='valid'" class="text-white text-center p-0 m-0">{{textValid}}</h5>
                <h5 v-if="textError" class="text-white text-center p-1 m-0">{{textError}}</h5>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2" style="justify-content: space-evenly !important;">
          <b-form @submit.prevent="modalShow=false" v-if="state==='invalid' || state==='valid'">
            <b-form-group style="position: absolute; z-index: -5; margin: 0; height: 1px; width: 1px;"
              id="input-group-1"
            >
              <b-form-input style="position: absolute; z-index: -100; margin: 0; height: 1px; width: 1px;"
              id="input-1"
              v-model="qr"
              ref="code-input"
              type="text"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="button-group" class="mb-0">
              <b-button class="rounded shadow"
                style='min-height: 60px; min-width: 200px ; font-size: 24px; font-weight: bold;' 
                variant="light"
                v-if="state==='invalid' || state==='valid' || state==='loading'"
                @click="modalShow=false"
              >Cerrar
              </b-button>
            </b-form-group>
          </b-form>
          <b-form @submit.prevent="showFormConfirm=true" v-else-if="state!='invalid'">
            <b-form-group style="position: absolute; z-index: -5; margin: 0; height: 1px; width: 1px;"
              id="input-group-1"
            >
              <b-form-input style="position: absolute; z-index: -100; margin: 0; height: 1px; width: 1px;"
              id="input-1"
              v-model="qr"
              ref="code-input"
              type="text"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="button-group" class="mb-0">
              <b-button class="rounded shadow"
                style='min-height: 60px; min-width: 200px ; font-size: 24px; font-weight: bold;' 
                variant="light"
                @click="showFormConfirm=true"
              >Autorizar
              </b-button>
            </b-form-group>
          </b-form>
          <!--<b-button class="rounded shadow" 
            style='min-height: 60px; min-width: 200px ; font-size: 24px; font-weight: bold;' 
            variant="light"
            @click="() => {showConfirmRedemption = true}"
            >Reembolsar
          </b-button>-->
        </b-row>
      </b-container>
      <b-modal
        id="confirm-modal"
        v-model="showFormConfirm"
        :title="`Autorizar`"
        ok-title="Ok"
        ok-variant="info"
        @hidden="oncancelConfirm"
        @ok.prevent="authorize"
      >
        <b-container class="p-0">
          <b-row v-if="state==='loading'">
            <b-col md="12">
              <div class="text-center">
                <b-spinner
                  label="Spinning"
                  style="color: #195db2; width: 4rem; height: 4rem"
                ></b-spinner>
              </div>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col md="12">
              <p class="text-center">
                ¿Esta seguro que desea autorizar la orden por ${{$formatDollar(instanceJson.order.amount)}}?
              </p>
            </b-col>
          </b-row>
        </b-container>
        <template v-slot:modal-footer="{ ok, cancel }">
          <b-button size="sm" variant="secondary" :disabled="state==='loading'" @click="cancel">
            Cancelar
          </b-button>
          <b-button size="sm" variant="primary" :disabled="state==='loading'" @click="ok">
            <span v-if="state!='loading'">
              Autorizar
            </span>
            <b-spinner v-if="state==='loading'" small label="Spinning" variant="light"> </b-spinner>
          </b-button>
        </template>
      </b-modal>
    </b-modal>
  </template>
  <style >
  
  #doctype .multiselect__tags {
    min-height: 48px;
    display: block;
    max-height: 30px;
    padding: 10px 40px 0 8px;
    border-radius: 5px 0px 0px 5px;
    border: 1px solid white;
    border-right: none;
    background: transparent;
    font-size: 14px
  }
  
  
  #doctype .multiselect__single{
  
    background: transparent;
    font-size: 20px;
    color: white;
    margin: 0px;
    margin-top: 4px;
  }
  
  #doctype .multiselect__input {
    background: transparent;
    font-size: 20px;
    color: white;
    text-transform: uppercase
  }
  #doctype .multiselect__input::placeholder {
    background: transparent;
    text-transform: none;
  
    font-size: 20px;
    color: rgba(255, 255, 255, 0.788);
  }
  
  #doctype .multiselect__select {
    margin-top: 6px;
  }
  
  #doctype .multiselect--disabled .multiselect__current, #doctype .multiselect--disabled .multiselect__select {
    background: none;
  }
  
  #doctype .multiselect--disabled {
    opacity: .3;
  }
  
  .border_celda{
    border: 1px solid white;
    padding: 8px;
  }
  
  .coupon {
    width: 660px;
    height: 400px;
    margin: 2rem auto;
    border-radius: 0.5rem;
    /* background: linear-gradient(red,#2c3e50); */
    background-image: linear-gradient(
      140deg,
      hsl(235deg 67% 13%) 0%,
      hsl(230deg 64% 16%) 21%,
      hsl(227deg 62% 20%) 30%,
      hsl(225deg 61% 23%) 39%,
      hsl(222deg 61% 26%) 46%,
      hsl(220deg 63% 29%) 54%,
      hsl(217deg 65% 32%) 61%,
      hsl(215deg 68% 35%) 69%,
      hsl(213deg 72% 37%) 79%,
      hsl(210deg 77% 39%) 100%
    );
  
    -webkit-mask-image: radial-gradient(
      circle at 24px 50%,
      transparent 24px,
      red 24.5px
    );
    -webkit-mask-position: -24px;
  }
  
  .bg-valid {
    background-image: linear-gradient(
      135deg,
      hsl(135deg 91% 53%) 0%,
      hsl(138deg 100% 46%) 5%,
      hsl(136deg 100% 43%) 10%,
      hsl(133deg 100% 41%) 14%,
      hsl(129deg 100% 39%) 19%,
      hsl(124deg 100% 36%) 23%,
      hsl(120deg 100% 34%) 27%,
      hsl(120deg 100% 32%) 31%,
      hsl(120deg 100% 30%) 35%,
      hsl(120deg 100% 28%) 39%,
      hsl(120deg 100% 25%) 42%,
      hsl(120deg 100% 23%) 46%,
      hsl(120deg 100% 21%) 49%,
      hsl(120deg 100% 19%) 53%,
      hsl(120deg 100% 17%) 56%,
      hsl(120deg 100% 15%) 60%,
      hsl(120deg 100% 13%) 63%,
      hsl(120deg 100% 11%) 67%,
      hsl(120deg 100% 10%) 72%,
      hsl(120deg 100% 9%) 77%,
      hsl(120deg 100% 8%) 83%,
      hsl(0deg 0% 0%) 99%
    );
  }
  
  .bg-invalid {
    background-image: linear-gradient(
      135deg,
      hsl(0deg 87% 42%) 0%,
      hsl(357deg 100% 38%) 5%,
      hsl(359deg 100% 36%) 10%,
      hsl(0deg 100% 35%) 14%,
      hsl(0deg 100% 34%) 19%,
      hsl(0deg 100% 33%) 23%,
      hsl(0deg 100% 31%) 27%,
      hsl(0deg 100% 30%) 31%,
      hsl(0deg 100% 29%) 35%,
      hsl(0deg 100% 28%) 39%,
      hsl(0deg 100% 27%) 42%,
      hsl(0deg 100% 26%) 46%,
      hsl(0deg 100% 24%) 49%,
      hsl(0deg 100% 23%) 53%,
      hsl(0deg 100% 22%) 56%,
      hsl(0deg 100% 21%) 60%,
      hsl(0deg 100% 20%) 63%,
      hsl(0deg 100% 19%) 67%,
      hsl(0deg 100% 18%) 72%,
      hsl(0deg 100% 17%) 77%,
      hsl(0deg 100% 16%) 83%,
      hsl(0deg 0% 0%) 99%
    );
  }
  
  .bg-expired {
    background-image: linear-gradient(
      135deg,
      hsl(0deg 0% 68%) 0%,
      hsl(344deg 0% 64%) 5%,
      hsl(344deg 0% 61%) 10%,
      hsl(344deg 0% 57%) 14%,
      hsl(344deg 0% 54%) 19%,
      hsl(344deg 0% 51%) 23%,
      hsl(344deg 0% 47%) 27%,
      hsl(344deg 0% 44%) 31%,
      hsl(344deg 0% 41%) 35%,
      hsl(344deg 0% 37%) 39%,
      hsl(344deg 0% 34%) 42%,
      hsl(344deg 0% 31%) 46%,
      hsl(344deg 0% 28%) 49%,
      hsl(344deg 0% 25%) 53%,
      hsl(344deg 0% 22%) 56%,
      hsl(344deg 0% 19%) 60%,
      hsl(344deg 0% 16%) 63%,
      hsl(344deg 0% 14%) 67%,
      hsl(344deg 0% 11%) 72%,
      hsl(343deg 0% 8%) 77%,
      hsl(343deg 0% 5%) 83%,
      hsl(0deg 0% 0%) 99%
    );
  }
  .coupon::before {
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  }
  .btn-coupon {
    background-color: white;
  }
  .btn-coupon:hover {
    background-color: rgb(224, 222, 222);
  }
  .text-transparent {
    -webkit-text-fill-color: transparent;
  }
  
  .coupon .icon-animated {
    position: absolute;
    top: 1.5rem;
    right: 5.5rem;
  }
  .coupon .icon-logo {
    position: absolute;
    top: 1.5rem;
    left: 5.5rem;
  }
  
  .text-shadow {
    /* background-color: rgba(0, 0, 0, 0.39); */
    font-size: 30px;
    -webkit-text-stroke: .2px #000;
    text-shadow: 6px 2px 14px rgb(0, 0, 0);
  
  }
  
  .relative{
    position: relative;
    top: -40px
  }
  
  .btn-close {
    position: absolute;
    background: rgba(22, 6, 163, 0.623);
    left: -65px;
    z-index: 1;
    width: 70px;
    height: 70px;
    font-size: 30px;
  }
  </style>